import Swiper from 'swiper/dist/js/swiper';
import * as helpers from '../../js/helpers';

export default function publicationCoverflowSlider() {
    const publicationBlock = document.querySelector('.alire__container');

    if (publicationBlock === null) {
        return;
    }

    const carousels = document.querySelectorAll('.alire__carousel');
    [...carousels].forEach((el) => {
        const parent = helpers.findAncestor(el, 'alire');
        const slides = [...parent.querySelectorAll('.alire-item')];
        const looped = slides.length > 1;

        if (parent) {
            const next = parent.querySelector('.alire__control.-next');
            const prev = parent.querySelector('.alire__control.-prev');

            if (helpers.hasClass(parent, '-coverflow-right')) {
                const swiper = new Swiper(el, {
                    effect: 'coverflow',
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    loop: looped,
                    simulateTouch: true,
                    coverflowEffect: {
                        rotate: 0,
                        stretch: 85,
                        depth: 220,
                        modifier: 1,
                        slideShadows: false,
                    },
                    navigation: {
                        nextEl: next,
                        prevEl: prev,
                    },
                    breakpoints: {
                        767: {
                            slidesPerView: 1,
                            coverflowEffect: {
                                rotate: 0,
                                stretch: 0,
                                depth: 0,
                            },
                        },
                    },
                });
            }

            const publicationControl = parent.querySelectorAll('.alire__control');

            if (helpers.hasClass(el, 'swiper-container-horizontal')) {
                for (let i = 0; i < publicationControl.length; i++) {
                    publicationControl[i].style.display = 'block';
                }
            }

            if (!looped) {
                helpers.addClass(next, 'swiper-button-hidden');
                helpers.addClass(prev, 'swiper-button-hidden');
            }
        }
    });
}
